import { useState } from "react";
import arrow from "../../assets/right.svg";

const Question = ({ name, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={open ? "question opened-ques" : "question closed-ques"}
      onClick={(e) => {
        setOpen(!open);
      }}
    >
      <h1>
        {name}
        <span>
          <img src={arrow} width="20px" alt="" />
        </span>
      </h1>
      <div className="answer">
        {open && children}
      </div>
    </div>
  );
};

export default Question;
